// Converts an svg into base64 string. which is then converted to image with source of base64 string
export const getSVGImage = (svgString) => {
    const container = document.createElement("div");
    container.innerHTML = svgString;
    const svgImages = container.getElementsByTagName("svg");
    if (!svgImages.length) {
      console.warn("Not an svg Image", svgString);
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve(img);
      var svgString = new XMLSerializer().serializeToString(svgImages[0]);
      var base64 = btoa(svgString);
      var imgSource = `data:image/svg+xml;base64,${base64}`;
      img.setAttribute("src", imgSource);
    });
  };

  // Get bit map image data so that it can be added to map image list
  export const getImageData = (imageData) => {
    if (!imageData) {
        return;
    }  
    return createImageBitmap(imageData); 
  }